import { useState } from 'react';
import ClassCard from '../../../components/classCard';
import { Box, Typography, Container } from '@mui/material';
import { colors } from '../../../theme';
import styled from 'styled-components';
import GlobalButton from '../../../components/global/button';
import CreatePlan from './dialogs/create-plan';

import { useAppDispatch, useAppSelector } from '../../../hooks/hooks';

//icons
import { ReactComponent as PlusIcon } from '../../../assets/icons/plus-icon.svg';
import moment from "moment";
import {MOMENT_DATE_DISPLAY_FORMAT, MOMENT_DATE_FORMAT} from "../../../constants/date_format";

const List = (props) => {
    const { onGenerate, onLoadPlan } = props;

    const [isModalOpen, setIsModalOpen] = useState(false);

    const termPlannerState = useAppSelector((state) => state.termPlanner);

    const dayReports = termPlannerState.termPlans.filter((t: any) => t.type == 'day');
    const nightReports = termPlannerState.termPlans.filter((t: any) => t.type == 'night');

    return (
        <Container maxWidth="lg" sx={{ padding: '20px 30px', width: '100%' }}>
            <Box sx={{ textAlign: 'right', mb: '25px' }}>
                <GlobalButton
                    variant="contained"
                    text="Add New"
                    startIcon={<PlusIcon />}
                    onClick={() => {
                        setIsModalOpen(true);
                    }}
                />
            </Box>
            <Box
                sx={{
                    display: 'flex',
                }}
            >
                {/* Daytime */}
                <Box
                    sx={{
                        flex: 1,
                        marginRight: '40px',
                    }}
                >
                    <Typography variant="h3" sx={{ color: colors.navy }}>
                        Daytime
                    </Typography>
                    <Divider />
                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                        }}
                    >
                        {dayReports.map((o: any, i) => {
                            return <ClassCard key={i} term={o.termCode} dayClass={o.weekday} lastEdit={o.lastUpdated && moment(o.lastUpdated, MOMENT_DATE_FORMAT).format(MOMENT_DATE_DISPLAY_FORMAT)} onLoadPlan={() => onLoadPlan(o)} />;
                        })}
                    </Box>
                </Box>

                {/* Nighttime */}
                <Box
                    sx={{
                        flex: 1,
                        marginLeft: '40px',
                    }}
                >
                    <Typography variant="h3" sx={{ color: colors.navy }}>
                        Night-time
                    </Typography>
                    <Divider />
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                        }}
                    >
                        {nightReports.map((o: any, i) => {
                            return <ClassCard key={i} term={o.termCode} dayClass={o.weekday} lastEdit={o.lastUpdated && moment(o.lastUpdated, MOMENT_DATE_FORMAT).format(MOMENT_DATE_DISPLAY_FORMAT)} onLoadPlan={() => onLoadPlan(o)} />;
                        })}
                    </Box>
                </Box>
            </Box>
            <CreatePlan open={isModalOpen} setOpen={setIsModalOpen} onGenerate={onGenerate} />
        </Container>
    );
};

export default List;

const Divider = styled.hr`
    border: none;
    background-color: ${colors.grey.medium};
    height: 1px;
    margin: 20px 0;
`;
